module.exports = __webpack_public_path__ + "img/kaspro_supply.0d708892.webp";